// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".x_bK82u6c72miYSoLtmY{background:rgba(0,0,0,.3);border-radius:4px;font-size:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"expandButton": "x_bK82u6c72miYSoLtmY"
};
export default ___CSS_LOADER_EXPORT___;
